var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"theme public skin--",class:_vm.themeNs},[_c('keep-alive',[_c(_vm.layout,{tag:"component",staticClass:"layout"},[_c(_vm.module(),{ref:"currentModule",tag:"component",staticClass:"module",class:_vm.className})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bab7a97","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layouts/shell/public.vue
// module id = PFVT
// module chunks = 12